import { BackgroundImageType } from 'common/types/common-types'
import React from 'react'
import {
  CommonBodyBackgroundUi,
  CommonBodyBackgroundUiProps,
} from '../body/ui/body-background-ui'
import { CommonBlogPostBodyUi } from './ui/blog-post-body-ui'

interface CommonBlogPostBodyProps extends CommonBodyBackgroundUiProps {
  children?: React.ReactNode
  isClient?: boolean
  backgroundImage?: BackgroundImageType
  mobileBackgroundImage?: BackgroundImageType
  zIndex?: number | null
}

export const CommonBlogPostBody = ({
  children,
  ...styles
}: CommonBlogPostBodyProps) => {
  return (
    <CommonBlogPostBodyUi>
      <CommonBodyBackgroundUi {...styles} />
      {children}
    </CommonBlogPostBodyUi>
  )
}
